import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CS_BASE_URL } from '../utils/ProjectUrls';
import { DetectedUniquePart } from '../schemas/DetectedUniquePart';
import { ReturnParameterValue } from '../schemas/ReturnParameterValue';

const UNIQUE_PARTS_PATH = '/unique-parts';

// 使用createApi创建一个新的API slice
// Use createApi to create a new API slice
export const uniquePartSlice = createApi({
    reducerPath: 'unique-parts',
    // Set the base URL for API requests
    baseQuery: fetchBaseQuery({ baseUrl: CS_BASE_URL }),

    // Define the API endpoints
    endpoints: (builder) => ({
        // Define a query endpoint for fetching uniquepart data
        getUniquePart: builder.query<DetectedUniquePart, { basePn: string; displayArea?: string }>({
            // Specify the specific path for the request
            query: ({ basePn, displayArea }) => {
                const queryString = displayArea
                    ? `?displayArea=${encodeURIComponent(displayArea)}`
                    : '';
                return `${UNIQUE_PARTS_PATH}/${basePn}${queryString}`;
            },
        }),
        getUniquePartValues: builder.query<
            ReturnParameterValue[],
            { basePn: string; displayArea?: string }
        >({
            // Specify the specific path for the request
            query: ({ basePn, displayArea }) => {
                // Build the query string dynamically
                const queryString = displayArea
                    ? `values?displayArea=${encodeURIComponent(displayArea)}`
                    : '';
                return `${UNIQUE_PARTS_PATH}/${basePn}/${queryString}`;
            },
        }),
        // More endpoints can be added here
    }),
});

// Export the auto-generated hook from the definitionSlice
export const { useLazyGetUniquePartQuery, useLazyGetUniquePartValuesQuery } = uniquePartSlice;
